module.exports = __webpack_public_path__ + "img/mob_comproblem_banner.bef4d572.png";